<template>
    <button
        :class="['icon-button', sizeClass]"
        :style="{ width: size + 'px', height: size + 'px' }"
        v-on="$listeners"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: 'ui-icon-button',
    props: {
        size: {
            type: Number,
            default: 24,
            validator: value => [16, 24, 48].includes(value),
        },
    },
    computed: {
        sizeClass() {
            return `icon-button--size-${this.size}`;
        },
    },
};
</script>

<style scoped>
.icon-button {
    border: none;
    border-radius: 50%;
    background-color: #F0EBF7;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    outline: none;
}
.icon-button:hover {
    background-color: #e9d4f6;
}

.icon-button--size-16 {
    font-size: 16px;
}

.icon-button--size-24 {
    font-size: 24px;
}

.icon-button--size-48 {
    font-size: 48px;
}
</style>
